import React, {memo} from 'react';
import {isEqual} from 'lodash';
import {labels} from '../../../../../../../util/utils';

const noRowsOverlayComponent = memo(() => {
	return <div className="ag-overlay-loading-center">{labels.noBodies}</div>;
}, isEqual);

noRowsOverlayComponent.displayName = 'NoRowsOverlay';

export default noRowsOverlayComponent;
